import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AuthStateService } from '../../app/auth/auth-state.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  private readonly authStateService = inject(AuthStateService);

  @Input() color = 'primary';
  @Input() title = 'Showlogger';
  @Input() topRightButton: string | null = null;
  @Input() hasBackButton = false;
  /** Fallback back-navigation target when there's no browser history. */
  @Input() backDefaultHref = '/';
  @Input() topRightButtonDisabled = false;
  /**
   * When true (default), the active show's primaryColor — if set — overrides
   * the `color` input on the toolbar. Set to false on pages where the toolbar
   * should always render in the colour passed in (e.g. the showreport edit
   * form, which is branded eventslight).
   */
  @Input() useShowColor = true;

  @Output() buttonClick: EventEmitter<any> = new EventEmitter();

  /**
   * Returns the effective color for the toolbar.
   * Uses show's primaryColor (hex) if available, otherwise falls back to the input color.
   * Returns null when `useShowColor` is false so the input `color` is used as-is.
   */
  public get effectiveColor(): string | null {
    if (!this.useShowColor) {
      return null;
    }
    const showColor = this.authStateService.activeShowPrimaryColor;
    return showColor ?? null;
  }

  /**
   * Returns the Ionic color attribute value.
   * Only used when no custom hex color is set.
   */
  public get ionicColor(): string | null {
    return this.effectiveColor ? null : this.color;
  }

  /**
   * Returns custom styles for the toolbar when using a hex color.
   */
  public get toolbarStyle(): { [key: string]: string } | null {
    const hexColor = this.effectiveColor;
    if (!hexColor) {
      return null;
    }
    return {
      '--background': hexColor,
      '--color': '#ffffff'
    };
  }

  public emitClick(): void {
    this.buttonClick.emit();
  }
}
